/* Vapor95 continuous scroll for collection pages (2026-11-03). Source: Documents\Vapor95-InfiniteScroll\theme\assets\v95-infinite.js
   The product grid (<ul data-v95-grid>) carries the next page's URL. When the shopper nears the bottom we fetch that page's
   section HTML, append its tiles and pick up the following URL. The normal page links stay in the HTML (search engines,
   no-JS) and are hidden once this runs. Re-arms after the theme's filter/sort swaps the results in. */
(() => {
  const CSS = `.v95-inf-on [data-v95-pages]{display:none}
.v95-inf{display:flex;align-items:center;justify-content:center;gap:8px;box-sizing:border-box;height:72px;padding:24px 0 12px;font-size:13px;letter-spacing:.08em;text-transform:uppercase;opacity:.75;overflow-anchor:none}
.v95-inf--end .v95-inf__dot{display:none}.v95-inf--end{opacity:.45}
.v95-inf[hidden]{display:none}
.v95-inf__dot{width:9px;height:9px;border-radius:50%;background:linear-gradient(135deg,#ff71ce,#b967ff,#01cdfe);animation:v95inf 1s ease-in-out infinite both}
.v95-inf__dot:nth-child(2){animation-delay:.15s}.v95-inf__dot:nth-child(3){animation-delay:.3s}
.v95-inf__txt{margin-left:6px}
.v95-inf--idle .v95-inf__dot{animation:none;opacity:.35}
@keyframes v95inf{0%,80%,100%{transform:scale(.6);opacity:.4}40%{transform:scale(1);opacity:1}}
@media (prefers-reduced-motion:reduce){.v95-inf__dot{animation:none}}`;
  if (!document.getElementById("v95-inf-css")) { const st = document.createElement("style"); st.id = "v95-inf-css"; st.textContent = CSS; document.head.appendChild(st); }

  const keyOf = (li) => { const a = li.querySelector('a[href*="/products/"]'); return a ? a.getAttribute("href").split("?")[0].replace(/^.*\/products\//, "") : null; };

  function setup(ul) {
    if (!ul || ul.dataset.v95InfReady) return;
    ul.dataset.v95InfReady = "1";
    let next = ul.dataset.next || "";
    const scope = ul.closest("#facets-filterable") || ul.closest(".shopify-section") || document;
    const pages = scope.querySelector("[data-v95-pages]");
    const loader = scope.querySelector("[data-v95-inf]");
    if (!next || !loader) return;                       // single page: nothing to do
    if (pages) pages.closest("[data-v95-pages]").parentElement.classList.add("v95-inf-on");
    loader.hidden = false; loader.classList.add("v95-inf--idle");
    const seen = new Set([...ul.children].map(keyOf).filter(Boolean));
    let busy = false, fails = 0;

    // end of the collection: keep the loader's 72px (removing it shrinks the page under a phone's thumb and the browser
    // snaps the scroll back up), just swap the dots for an end line
    const done = () => { io.disconnect(); loader.classList.remove("v95-inf--idle"); loader.classList.add("v95-inf--end");
      const t = loader.querySelector(".v95-inf__txt"); if (t) t.textContent = "That's everything"; };
    const giveUp = () => { io.disconnect(); loader.hidden = true; if (pages) pages.parentElement.classList.remove("v95-inf-on"); }; // show page links again

    async function load() {
      if (busy || !next) return;
      busy = true; loader.classList.remove("v95-inf--idle");
      try {
        const u = new URL(next, location.origin);
        u.searchParams.set("section_id", ul.dataset.section);
        const res = await fetch(u.toString(), { credentials: "same-origin" });
        if (!res.ok) throw new Error("HTTP " + res.status);
        const doc = new DOMParser().parseFromString(await res.text(), "text/html");
        const more = doc.querySelector("[data-v95-grid]");
        if (!more) throw new Error("no grid in response");
        const frag = document.createDocumentFragment();
        [...more.children].forEach((li) => {
          const k = keyOf(li);
          if (k && seen.has(k)) return;
          if (k) seen.add(k);
          frag.appendChild(document.importNode(li, true));
        });
        ul.appendChild(frag);
        next = more.dataset.next || "";
        fails = 0;
      } catch (err) {
        console.warn("[v95-infinite]", err);
        if (++fails >= 2) { busy = false; giveUp(); return; }
      }
      busy = false; loader.classList.add("v95-inf--idle");
      if (!next) return done();
      // still near the bottom (short pages, tall screens)? keep going
      io.unobserve(loader); io.observe(loader);
    }

    const io = new IntersectionObserver((ents) => { if (ents.some((e) => e.isIntersecting)) load(); }, { rootMargin: "0px 0px 1200px 0px" });
    io.observe(loader);
  }

  const boot = () => document.querySelectorAll("[data-v95-grid]").forEach(setup);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shapes:section:hasmutated", () => setTimeout(boot, 50));   // filters / sort re-rendered the grid
  document.addEventListener("shopify:section:load", boot);                             // theme editor
})();
